<div class="py-4" *ngIf="(getPosts$ | async) && latestPost">
  <div class="mb-4 px-4">{{ latestPost.title }}</div>

  <img
    [src]="latestPost.feature_image"
    [alt]="latestPost.feature_image_alt"
    mat-card-image
    draggable="false"
    *ngIf="latestPost.feature_image"
  />
  <div class="px-4">
    <p class="text-start">
      {{ latestPost.excerpt }}
      <a [routerLink]="['/blog/post', latestPost.slug]">{{
        "SIDENAV.BLOG_BLOCK.READ_FURTHER" | translate
      }}</a>
    </p>
    <div class="text-start" *ngIf="posts && posts.length > 0">
      {{ "SIDENAV.BLOG_BLOCK.OLDER_POSTS" | translate }}
      <ul>
        <li *ngFor="let post of posts" class="post-card-content">
          <a [routerLink]="['/blog/post', post.slug]">{{ post.title }}</a>
        </li>
        <li *ngIf="allPostsCount && allPostsCount > lastPostSize">
          <a [routerLink]="['/blog/posts']">{{
            "SIDENAV.BLOG_BLOCK.MORE_POSTS" | translate
          }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>
